<template>
	<HookCustom v-if="config && config.login" :componente="config.login" @loginsuccess="getDatosUsuario"/>
</template>

<script>
	import VueJwtDecode from 'vue-jwt-decode'
	import HookCustom from '@/components/Porlet/PorletHookCustom.vue'
	import { mapActions, mapMutations, mapState } from 'vuex'
	
	export default {
		name: 'SignIn',
		components: {
			HookCustom
		},
		computed: {
			...mapState({
				config: state => state.config.data
			})
		},
		methods: {
			...mapActions([
				'FETCH_USER'
			]),
			...mapMutations([
				'setUser'
			]),
			async getDatosUsuario(token) {

				if (!token) return
				
				let user = VueJwtDecode.decode(token)
				
				this.setUser(user)
				
				let redirect = localStorage.getItem('redirect')
				
				if (redirect) {

					let path = window.distributionapp.publicPath ? `/${window.distributionapp.publicPath}/${redirect}` : `/${redirect}`

					localStorage.removeItem('redirect')

					this.$router.push({ path: redirect })

				} else {

					this.$router.push({ name: 'inicio' })
				}
			}
		}
	}
</script>
